import React from 'react';
import { CheckIcon, ClockIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import LoadingSpinner from '../LoadingSpinner';

const AvailabilityStatusChip = ({ isSaving, lastSaved, hasUnsavedChanges }) => {
  const getStatusInfo = () => {
    if (isSaving) {
      return {
        text: 'Saving...',
        icon: <LoadingSpinner size="sm" className="mr-1" />,
        bgColor: 'bg-blue-100',
        textColor: 'text-blue-700',
        borderColor: 'border-blue-200',
      };
    }

    if (hasUnsavedChanges) {
      return {
        text: 'Unsaved changes',
        icon: <ClockIcon className="mr-1 h-3 w-3" />,
        bgColor: 'bg-yellow-100',
        textColor: 'text-yellow-700',
        borderColor: 'border-yellow-200',
      };
    }

    if (lastSaved) {
      return {
        text: `Saved ${formatTimeAgo(lastSaved)}`,
        icon: <CheckIcon className="mr-1 h-3 w-3" />,
        bgColor: 'bg-green-100',
        textColor: 'text-green-700',
        borderColor: 'border-green-200',
      };
    }

    return {
      text: 'No changes',
      icon: null,
      bgColor: 'bg-gray-100',
      textColor: 'text-gray-600',
      borderColor: 'border-gray-200',
    };
  };

  const formatTimeAgo = (date) => {
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) {
      return 'just now';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes}m ago`;
    } else {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours}h ago`;
    }
  };

  const status = getStatusInfo();

  return (
    <div
      className={`inline-flex items-center rounded-full border px-2 py-1 text-xs font-medium ${status.bgColor} ${status.textColor} ${status.borderColor}`}
    >
      {status.icon}
      {status.text}
    </div>
  );
};

export default AvailabilityStatusChip;
